enum ReportStatus {
  UPLOADING = "UPLOADING",
  ANALYSING = "ANALYSING",
  AVAILABLE = "AVAILABLE",
  SHARED_WITH_PATIENT = "SHARED_WITH_PATIENT",
  VIEWED_BY_PATIENT = "VIEWED_BY_PATIENT",
  REJECTED = "REJECTED",
  INCOMPLETE = "INCOMPLETE",
  TECHNICAL_ERROR = "TECHNICAL_ERROR",
}

export default ReportStatus;
